/** Provides the API implementation chosen at start-up (app/api_bootstrap.ts) to the component tree. */
import type { ReactNode } from 'react';
import { ApiContext, type ApiContextValue } from './api_context';

export function ApiProvider({ value, children }: { value: ApiContextValue; children: ReactNode }) {
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}
